import React from 'react';

const SelectionDropDown = ({
  singleProduct,
  variantOptions,
  handleSelectVariantChange,
}) => {
  const selected = singleProduct.merchantProductSku;
  return (
    <select value={selected} onChange={handleSelectVariantChange}>
      {variantOptions.map(variantOption => (
        <option
          id={variantOption.id}
          value={variantOption.id}
          key={variantOption.id}
          className="xrs-product__option-text"
        >
          {variantOption.value}
        </option>
      ))}
    </select>
  );
};

export default SelectionDropDown;
